import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <IndexSection />
        <AboutSection />
        <TopicsSection />
        <MediaSection />
        <FAQSection />
        <RankingSection />
        <CommentsSection />
        <FeaturesSection />
        <ContactSection />
        <AppSection />
        <CarouselSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}